import React from "react";
import "./emptyTodos.css";

function EmptyTodos() {
  return <p>No hay TODO's para mostrar</p>;
}

export { EmptyTodos };
